<template>
	<div class="invoice">
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span v-if="this.$route.query.id == undefined">添加发票信息</span>
			<span v-else>更改发票信息</span>
			<div></div>
		</div>
		<div class="block">
			<van-form validate-first @submit="onFailed">
				<van-field name="type1" label="开具类型:">
					<template #input>
						<van-radio-group checked-color="#F1452F" v-model="type1" icon-size="16px" name="type1" direction="horizontal">
							<van-radio name="0">企业</van-radio>
							<van-radio name="1">个人</van-radio>
						</van-radio-group>
					</template>
				</van-field>
				<van-field v-model="title" label="发票抬头:" name="title" placeholder="" />
				<van-field v-model="number" label="税务登记证号:" name="number" placeholder="" />
				<van-field v-model="address" label="注册场所地址:" name="address" placeholder="" />
				<van-field v-model="tel" label="注册固定电话:" name="tel" placeholder="" />
				<van-field v-model="name" label="开户银行名称:" name="name" placeholder="" />
				<van-field v-model="card" label="基本开户账号:" name="card" placeholder="" />
				<div class="bottom" style="margin: 16px;">
					<van-button style="height: 2rem; line-height: 2rem;" round block type="info" color="#F1452F" native-type="submit">
						提交
					</van-button>
				</div>
			</van-form>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				title: '',
				number: '',
				address: '',
				tel: '',
				name: '',
				card: '',
				form: "",
				type1: '0'
			}
		},
		created() {
			if (this.$route.query.id != undefined) {
				this.$axios.post(baseUrl + '/mobile/Bill/one', {
					token: localStorage.getItem('Authorization'),
					id: this.$route.query.id
				}).then((res) => {
					this.title = res.data.data.title
					this.number = res.data.data.number
					this.address = res.data.data.address
					this.tel = res.data.data.tel
					this.name = res.data.data.name
					this.card = res.data.data.card
					this.type1 = res.data.data.type1
					this.type2 = res.data.data.type2
				}).catch((err) => {
					console.log(err);
				});
			}
		},
		methods: {
			onFailed(errorInfo) {
				if (this.type1 == 0) {
					if (this.title == '') {
						this.$toast('发票抬头错误');
						return false;
					};
					if (this.number == '') {
						this.$toast('税务登记证号错误');
						return false;
					};
				} else {
					if (this.title == '') {
						this.$toast('发票抬头错误');
						return false;
					};
				};
				if (this.$route.query.id == undefined) {
					// 添加地址
					this.form == errorInfo;
					errorInfo.token = localStorage.getItem('Authorization')
					this.$axios.post(baseUrl + '/mobile/Bill/add', errorInfo).then((res) => {
						this.$toast("添加成功");
						this.$router.push({
							path: "/overinvoices"
						})
					}).catch((err) => {
						console.log(err);
					});
				} else {
					// 修改地址
					this.form == errorInfo;
					errorInfo.token = localStorage.getItem('Authorization');
					errorInfo.id = this.$route.query.id;
					this.$axios.post(baseUrl + '/mobile/Bill/update', errorInfo).then((res) => {
						this.$toast("修改成功");
						this.$router.push({
							path: "/overinvoices"
						})
					}).catch((err) => {
						console.log(err);
					});
				}
			},
		}
	}
</script>

<style>
	.invoice .block {
		width: 94%;
		margin: auto;
		background-color: #fff;
		margin-top: 3.125rem;
		border-radius: 0.65rem;
		padding: 0.875rem 0;
	}

	.invoice .van-cell__title {
		text-align: left;
	}

	.invoice .van-cell {
		line-height: 36px;
	}

	.invoice .van-radio--horizontal {
		margin-top: 0.5rem;
	}

	.invoice .van-cell__value {
		margin-left: 0.9375rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/invoice/invoice.vue